import theme from 'src/components/themes/DefaultTheme';
import styled from 'src/lib/styles/css';


//#region [Styles]
const SPosterContainer = styled.section`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	grid-gap: 13px;
	margin-top: 10px;
	margin-bottom: 10px;
	position: relative;
	z-index: 1;


	@media (min-width: 550px) {
        /*@media (orientation: landscape) {*/
        grid-template-columns: repeat(6, minmax(0, 1fr));
        grid-gap: 40px;
        margin-bottom: 40px;
    }
`;

export default SPosterContainer;
//#endregion